function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "grid"
}, React.createElement("g", {
  id: "background"
}, React.createElement("circle", {
  cx: 119.99965,
  cy: 119.99964,
  r: 119.50001,
  transform: "translate(-17.67231 219.22796) rotate(-80.78252)",
  fill: "#f5ed85"
}), React.createElement("path", {
  d: "M120,1a119,119,0,0,1,84.14569,203.14575A119,119,0,0,1,35.85427,35.85425,118.22138,118.22138,0,0,1,120,1m0-1A120,120,0,1,0,240,120,120,120,0,0,0,120,0Z",
  fill: "#2e4f4f"
})), React.createElement("g", {
  id: "metaballs"
}, React.createElement("path", {
  d: "M161.33588,210.40585a14.37431,14.37431,0,0,1-3.70293-.49852l.00973.01683c-13.25806-3.51824-20.2071.51611-23.72533,13.77426l-.0099-.01709a14.38049,14.38049,0,0,1-27.80619.03391l-.00964.01675c-3.576-13.34593-10.58533-17.39279-23.93125-13.81671l.00955-.01649a14.39349,14.39349,0,1,1,10.16249-17.60193l.00964-.01674c3.576,13.34592,10.58533,17.39279,23.93126,13.81671l-.00956.01649a14.01,14.01,0,0,1,7.43918-.00854l-.00972-.01683c13.25814,3.51824,20.20709-.51611,23.72541-13.77426l.0099.01708a14.39272,14.39272,0,1,1,13.90736,18.07508Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M47.04844,161.65264c-9.76917-9.76959-9.76917-17.86265,0-27.63224a14.39909,14.39909,0,1,0-20.3627-.00059c9.76985,9.76993,9.76985,17.86349,0,27.63342a14.399,14.399,0,1,0,20.3627-.00059Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M213.31375,113.82963c-9.76917-9.76959-9.76917-17.86264,0-27.63224a14.39908,14.39908,0,1,0-20.36269-.00059c9.76984,9.76993,9.76984,17.86349,0,27.63342a14.399,14.399,0,1,0,20.36269-.00059Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M161.33588,37.59407a14.37387,14.37387,0,0,0-3.70293.49852l.00973-.01683c-13.25806,3.51824-20.2071-.51611-23.72533-13.77426h0a14.44511,14.44511,0,1,0-10.21442,17.59372l-.00972.01683c13.25814-3.51832,20.20709.51611,23.72541,13.77418l.0099-.01709a14.39272,14.39272,0,1,0,13.90736-18.07507Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M202.67178,157.43585a14.37425,14.37425,0,0,0-3.70293.49852l.00973-.01683c-13.25807,3.51824-20.2071-.51611-23.72534-13.77426l-.00989.01708A14.43269,14.43269,0,1,0,165.03883,161.737l-.00973.01682c13.25815-3.51832,20.2071.51612,23.72542,13.77418l.0099-.01708a14.39272,14.39272,0,1,0,13.90736-18.07508Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M119.76956,109.43919a14.37389,14.37389,0,0,0-3.70294.49852l.00973-.01683c-13.25806,3.51824-20.2071-.51611-23.72533-13.77426l-.0099.01708A14.43273,14.43273,0,1,0,82.1366,113.74034l-.00972.01683c13.25814-3.51832,20.20709.51611,23.72541,13.77418l.0099-.01709a14.39272,14.39272,0,1,0,13.90737-18.07507Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M119.76956,157.43585a14.37433,14.37433,0,0,0-3.70294.49852l.00973-.01683c-13.25806,3.51824-20.2071-.51611-23.72533-13.77426l-.0099.01708A14.43269,14.43269,0,1,0,82.1366,161.737l-.00972.01682C95.385,158.23551,102.334,162.27,105.85229,175.528l.0099-.01708a14.39272,14.39272,0,1,0,13.90737-18.07508Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M161.33588,85.44085a14.37388,14.37388,0,0,0-3.70293.49853l.00973-.01683c-13.25806,3.51823-20.2071-.51611-23.72533-13.77426l-.0099.01708A14.3262,14.3262,0,0,0,116.26383,61.9496l.00948-.0164c-13.34593,3.576-20.35526-.47087-23.93126-13.81671l-.00964.01674a14.38066,14.38066,0,0,0-27.79748,0l-.00964-.01674C60.94929,61.46233,53.94,65.50919,40.594,61.9332l.00947.0164A14.39347,14.39347,0,1,0,50.76608,79.55153l.00964.01674c3.576-13.34592,10.58533-17.3927,23.93126-13.81671l-.00948-.0164a14.01814,14.01814,0,0,0,7.47234,0l-.00947.0164c13.34592-3.576,20.35525.47079,23.93125,13.81671l.00964-.01674A14.32426,14.32426,0,0,0,123.70293,89.742l-.00972.01683c13.25814-3.51832,20.20709.51611,23.72541,13.77418l.0099-.01709a14.39272,14.39272,0,1,0,13.90736-18.07508Z",
  fill: "none",
  stroke: "#587272",
  strokeMiterlimit: 10
})), React.createElement("g", {
  id: "time"
}, React.createElement("g", {
  id: "time-businessXhours"
}, React.createElement("circle", {
  cx: 36.86734,
  cy: 123.83821,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(33.80942 127.81658)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y")), React.createElement("g", {
  id: "time-afterXbusinessXhours"
}, React.createElement("circle", {
  cx: 36.86734,
  cy: 171.83487,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(33.80921 175.41657)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N"))), React.createElement("g", {
  id: "type_of_abuse"
}, React.createElement("g", {
  id: "type_of_abuse-both"
}, React.createElement("circle", {
  cx: 161.3359,
  cy: 195.8332,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(158.33569 199.79086)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "B")), React.createElement("g", {
  id: "type_of_abuse-physical"
}, React.createElement("circle", {
  cx: 78.43367,
  cy: 196.18051,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(75.43397 199.79109)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "P")), React.createElement("g", {
  id: "type_of_abuse-verbal"
}, React.createElement("circle", {
  cx: 120,
  cy: 220.17884,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(117.00031 224.24179)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "V"))), React.createElement("g", {
  id: "incident_reported"
}, React.createElement("g", {
  id: "incident_reported-TRUE"
}, React.createElement("circle", {
  cx: 78.43367,
  cy: 147.83654,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(75.43397 151.41824)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y")), React.createElement("g", {
  id: "incident_reported-FALSE"
}, React.createElement("circle", {
  cx: 120,
  cy: 172.00852,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(117.00031 175.41657)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N"))), React.createElement("g", {
  id: "stayed_in_academia"
}, React.createElement("g", {
  id: "stayed_in_academia-TRUE"
}, React.createElement("circle", {
  cx: 161.3359,
  cy: 147.83654,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(158.33569 151.79421)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y")), React.createElement("g", {
  id: "stayed_in_academia-FALSE"
}, React.createElement("circle", {
  cx: 203.13266,
  cy: 171.83487,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(200.13289 175.41622)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N"))), React.createElement("g", {
  id: "successful_report"
}, React.createElement("g", {
  id: "successful_report-TRUE"
}, React.createElement("circle", {
  cx: 120,
  cy: 27.99476,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(117.00011 31.70584)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y")), React.createElement("g", {
  id: "successful_report-FALSE"
}, React.createElement("circle", {
  cx: 161.3359,
  cy: 51.84321,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(158.33569 55.42498)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N"))), React.createElement("g", {
  id: "at_conference"
}, React.createElement("g", {
  id: "at_conference-TRUE"
}, React.createElement("circle", {
  cx: 78.43367,
  cy: 99.83988,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(75.43397 103.42159)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y")), React.createElement("g", {
  id: "at_conference-FALSE"
}, React.createElement("circle", {
  cx: 120,
  cy: 123.83821,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(117.00031 127.41991)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N"))), React.createElement("g", {
  id: "hierarchy"
}, React.createElement("g", {
  id: "hierarchy-greater"
}, React.createElement("circle", {
  cx: 36.86734,
  cy: 75.84154,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(33.80941 79.57935)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "H")), React.createElement("g", {
  id: "hierarchy-equal"
}, React.createElement("circle", {
  cx: 78.43367,
  cy: 51.84321,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(75.43397 55.42492)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "E")), React.createElement("g", {
  id: "hierarchy-lesser"
}, React.createElement("circle", {
  cx: 120,
  cy: 75.84154,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(117.00031 79.42325)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "L")), React.createElement("g", {
  id: "hierarchy-mixed"
}, React.createElement("circle", {
  cx: 161.3359,
  cy: 99.83988,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(158.33569 103.79755)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "M"))), React.createElement("g", {
  id: "avoided_people_or_places"
}, React.createElement("g", {
  id: "avoided_people_or_places-FALSE"
}, React.createElement("circle", {
  cx: 203.13266,
  cy: 123.83821,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(200.13289 127.41956)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "N")), React.createElement("g", {
  id: "avoided_people_or_places-TRUE"
}, React.createElement("circle", {
  cx: 203.13266,
  cy: 75.84154,
  r: 9.59933,
  fill: "#fafafa",
  stroke: "#2e4f4f",
  strokeMiterlimit: 10
}), React.createElement("text", {
  transform: "translate(200.13289 79.42289)",
  fontSize: 12,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata",
  letterSpacing: "0.04997em"
}, "Y"))), React.createElement("text", {
  transform: "translate(184.75832 78.31214) rotate(-89.63032)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(184.78859 73.22034) rotate(-74.14291)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "v"), React.createElement("text", {
  transform: "matrix(0.52576, -0.85063, 0.85063, 0.52576, 186.19094, 68.33069)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "matrix(0.736, -0.67698, 0.67698, 0.736, 188.8677, 64.01819)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(192.64113 60.56702) rotate(-26.77599)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(197.17531 58.29065) rotate(-10.93612)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(202.16945 57.34143) rotate(4.70627)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(207.2632 57.77503) rotate(20.6347)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(212.01711 59.57971) rotate(36.44804)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "matrix(0.61327, 0.78988, -0.78988, 0.61327, 216.11086, 62.61878)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(219.2173 66.63635) rotate(67.95602)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "translate(221.11574 71.36389) rotate(83.79891)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "translate(221.64992 76.42639) rotate(99.4464)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "l"), React.createElement("text", {
  transform: "matrix(-0.42807, 0.90374, -0.90374, -0.42807, 220.72414, 81.40491)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "matrix(-0.63575, 0.77189, -0.77189, -0.63575, 218.5259, 86.00452)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(214.5093 90.31214) rotate(125.23159)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "matrix(-0.02558, 0.99967, -0.99967, -0.02558, 210.29543, 97.16956)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "matrix(0.56201, 0.82713, -0.82713, 0.56201, 211.4468, 105.10999)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(215.2173 110.16956) rotate(45.43277)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "translate(218.55422 113.87366) rotate(64.468)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "l"), React.createElement("text", {
  transform: "translate(220.81008 118.42639) rotate(80.3465)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(221.65285 123.44788) rotate(96.02306)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(221.10793 128.51624) rotate(111.87208)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(219.20461 133.22522) rotate(127.644)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.67144, -0.74106, 0.74106, 0.67144, 146.04934, 137.68909)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.84745, -0.53087, 0.53087, 0.84745, 149.48488, 133.9176)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "translate(153.80031 131.22717) rotate(-16.21291)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(158.68605 129.84143) rotate(-0.92521)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "y"), React.createElement("text", {
  transform: "translate(163.78273 129.79065) rotate(15.33823)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "matrix(0.85441, 0.51959, -0.51959, 0.85441, 168.69973, 131.15589)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(173.03371 133.80725) rotate(47.01344)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "matrix(0.45783, 0.88904, -0.88904, 0.45783, 176.47316, 137.55042)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(178.64406 142.276) rotate(71.71305)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "matrix(0.57706, 0.8167, -0.8167, 0.57706, 180.8091, 148.68909)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(187.08742 154.93128) rotate(8.42881)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(193.79348 155.30432) rotate(-9.02196)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(199.03469 154.19592) rotate(-4.40451)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(204.09426 153.65296) rotate(10.71239)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(209.10695 154.61389) rotate(26.59668)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(213.6509 156.90296) rotate(42.35538)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "m"), React.createElement("text", {
  transform: "matrix(0.52822, 0.84911, -0.84911, 0.52822, 217.41066, 160.3512)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "matrix(0.27624, 0.96109, -0.96109, 0.27624, 220.08937, 164.67639)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(72.10305 178.62756) rotate(-11.03148)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "matrix(0.99671, 0.08106, -0.08106, 0.99671, 77.10109, 177.66858)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "y"), React.createElement("text", {
  transform: "matrix(0.93648, 0.35071, -0.35071, 0.93648, 82.16945, 178.09046)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "matrix(0.80509, 0.59315, -0.59315, 0.80509, 86.92629, 179.88733)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "matrix(0.61437, 0.78902, -0.78902, 0.61437, 91.01809, 182.91565)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(94.12941 186.95667) rotate(67.71332)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "matrix(0.36018, 0.93288, -0.93288, 0.36018, 95.91457, 192.21936)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "f"), React.createElement("text", {
  transform: "translate(98.93605 199.17249) rotate(41.40359)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(106.25734 203.41077) rotate(-0.70029)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(112.27785 202.81799) rotate(-8.21223)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "b"), React.createElement("text", {
  transform: "translate(117.42434 202.0426) rotate(0.83865)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "u"), React.createElement("text", {
  transform: "translate(122.61281 202.25159) rotate(9.19068)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "translate(128.76906 203.51038) rotate(-1.03824)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(24.84133 158.14221) rotate(-52.11777)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "b"), React.createElement("text", {
  transform: "translate(29.29641 151.71155) rotate(-83.0161)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "u"), React.createElement("text", {
  transform: "translate(28.7593 143.47424) rotate(-122.08038)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "translate(24.99855 139.38831) rotate(-114.17066)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(21.71096 134.4928) rotate(-116.39879)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "translate(19.38771 129.96936) rotate(-100.52363)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "matrix(0.09045, -0.9959, 0.9959, 0.09045, 18.47268, 124.96448)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.35826, -0.93362, 0.93362, 0.35826, 18.93996, 119.90979)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.59889, -0.80083, 0.80083, 0.59889, 20.77346, 115.1676)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "matrix(0.79362, -0.60842, 0.60842, 0.79362, 23.83889, 111.09339)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "h"), React.createElement("text", {
  transform: "translate(27.89992 107.99475) rotate(-21.61227)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "matrix(0.99488, -0.10104, 0.10104, 0.99488, 32.61867, 106.13928)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "u"), React.createElement("text", {
  transform: "matrix(0.98523, 0.17123, -0.17123, 0.98523, 37.68508, 105.63538)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "translate(42.68898 106.51624) rotate(25.72508)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "translate(68.57668 132.46741) rotate(-24.4172)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(73.22219 130.37464) rotate(-8.50715)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "translate(78.2593 129.63342) rotate(7.1585)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(83.29641 130.276) rotate(23.04706)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(87.98098 132.28577) rotate(38.90123)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(91.93508 135.4928) rotate(54.60961)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(94.855 139.68421) rotate(69.73286)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "translate(96.56105 145.25745) rotate(66.29158)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "matrix(0.84079, 0.54136, -0.54136, 0.84079, 100.25734, 152.37366)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(107.73781 155.49573) rotate(-4.0373)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "translate(113.47023 154.651) rotate(-8.38935)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(118.56496 153.76526) rotate(3.70018)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "translate(123.65578 154.02503) rotate(19.49179)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "translate(128.4507 155.73694) rotate(35.33059)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "matrix(0.62846, 0.77784, -0.77784, 0.62846, 132.60305, 158.69592)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "translate(135.78371 162.65003) rotate(66.80603)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(137.77395 167.32288) rotate(82.66701)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "d"), React.createElement("text", {
  transform: "translate(58.5718 51.70276) rotate(-71.00368)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "h"), React.createElement("text", {
  transform: "translate(60.0718 46.57288) rotate(-65.06339)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "i"), React.createElement("text", {
  transform: "translate(62.21047 41.93323) rotate(-49.33558)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(65.51809 38.09631) rotate(-33.69007)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "translate(69.76711 35.27991) rotate(-17.77242)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(74.62258 33.73987) rotate(-1.90319)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "translate(79.71242 33.57874) rotate(13.83895)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(84.63234 34.80237) rotate(29.70366)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "h"), React.createElement("text", {
  transform: "translate(89.06105 37.34729) rotate(45.51843)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "y"), React.createElement("text", {
  transform: "matrix(0.80445, -0.59403, 0.59403, 0.80445, 106.63234, 14.55237)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "matrix(0.93581, -0.3525, 0.3525, 0.93581, 110.73, 11.54065)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "matrix(0.99649, -0.08374, 0.08374, 0.99649, 115.49074, 9.76135)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "p"), React.createElement("text", {
  transform: "matrix(0.98192, 0.18929, -0.18929, 0.98192, 120.57375, 9.34436)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "translate(125.55129 10.31506) rotate(26.79208)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "matrix(0.73629, 0.67666, -0.67666, 0.73629, 130.09035, 12.62171)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "matrix(0.52507, 0.85106, -0.85106, 0.52507, 133.81398, 16.10413)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "matrix(0.31751, 0.94825, -0.94825, 0.31751, 136.40578, 20.51917)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "translate(138.19875 26.4762) rotate(61.53287)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "u"), React.createElement("text", {
  transform: "translate(143.06203 33.48889) rotate(20.76978)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(150.37551 35.18421) rotate(-7.28992)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "matrix(0.99191, -0.12691, 0.12691, 0.99191, 155.81887, 34.15198)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(160.87355 33.31702) rotate(6.34524)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.92631, 0.37676, -0.37676, 0.92631, 165.93312, 33.88831)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "s"), React.createElement("text", {
  transform: "matrix(0.78812, 0.61553, -0.61553, 0.78812, 170.65676, 35.82678)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "f"), React.createElement("text", {
  transform: "translate(174.6675 38.97717) rotate(53.7254)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "u"), React.createElement("text", {
  transform: "translate(177.6675 43.08264) rotate(69.53422)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "l"), React.createElement("text", {
  transform: "matrix(0.55362, -0.83277, 0.83277, 0.55362, 61.5757, 91.7721)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "a"), React.createElement("text", {
  transform: "translate(64.41164 87.53186) rotate(-40.64066)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "t"), React.createElement("text", {
  transform: "translate(68.28469 84.22327) rotate(-24.85524)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}), React.createElement("text", {
  transform: "translate(72.88234 82.10413) rotate(-9.05047)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(77.9341 81.31604) rotate(6.67747)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "o"), React.createElement("text", {
  transform: "translate(82.9673 81.91467) rotate(22.53304)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "translate(87.65773 83.87464) rotate(38.3633)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "f"), React.createElement("text", {
  transform: "matrix(0.58651, 0.80994, -0.80994, 0.58651, 91.64309, 87.05335)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(94.60402 91.19788) rotate(69.31409)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "r"), React.createElement("text", {
  transform: "matrix(0.39691, 0.91786, -0.91786, 0.39691, 96.34133, 96.73499)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"), React.createElement("text", {
  transform: "translate(99.86379 103.75159) rotate(35.23509)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "n"), React.createElement("text", {
  transform: "translate(107.30227 107.19202) rotate(-2.87226)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "c"), React.createElement("text", {
  transform: "translate(113.14699 106.44495) rotate(-9.00989)",
  fontSize: 10,
  fill: "#2e4f4f",
  fontFamily: "Inconsolata-Regular, Inconsolata"
}, "e"));

var SvgElementsGrid = function SvgElementsGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgElementsGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elements_grid.237b88ef.svg";
export { ForwardRef as ReactComponent };